module.exports = __webpack_public_path__ + "media/images/common/header/sub_fp-a08ba258b3f91c9967c77367a5e7f11d.svg";